import { render, staticRenderFns } from "./CAxAFAxFamiliarPt3Page.vue?vue&type=template&id=146a0ae2"
import script from "./CAxAFAxFamiliarPt3Page.vue?vue&type=script&lang=js"
export * from "./CAxAFAxFamiliarPt3Page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports